import clsx from "clsx";
import { BlurredIconTile } from "../../../common/ImageTile/BlurredIconTile";
import styles from "./CreatorsLensTile.module.css";
export function CreatorsLensTile({ lensIconUrl, thumbnailUrl, hideIconOverlay, alt, border, }) {
    return (<div className={styles.containerContent} data-testid="creatorsLensTile">
      {thumbnailUrl ? (<img className={clsx(styles.tileMedia, { [styles.tileBorder]: border })} src={thumbnailUrl} alt={alt}/>) : (<div className={clsx(styles.tileMedia, { [styles.tileBorder]: border })}>
          <BlurredIconTile iconUrl={lensIconUrl} previewImageUrl={lensIconUrl} size="small" hideIconOverlay={hideIconOverlay} alt={alt}/>
        </div>)}
    </div>);
}
